import CouponProvider from './Coupon/Coupon.provider';
import { ProductBundleProvider } from './ProductBundle/ProductBundle.provider';

export const ProductBundleContextProvider = ({
  children,
}: {
  children: JSX.Element;
}) => (
  <ProductBundleProvider>
    <CouponProvider>{children}</CouponProvider>
  </ProductBundleProvider>
);

ProductBundleContextProvider.displayName = 'ProductBundleContextProvider';
